import React from 'react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import { Input, Button } from 'semantic-ui-react';

class Branch extends React.Component {

  state = {
    items: [],
    executive: [],
    removedData: []
  }

  componentDidMount() {

  }

  componentDidUpdate(props) {
    if (props.branch != this.props.branch || props.customertype != this.props.customertype) {
      this.getExecutive(this.props.branch, this.props.customertype);
    }
  }

  getExecutive(branch, customertype) {
    let context = this;
    context.setState({ load: true, message: 'Get Branch Executive!!!!' })
    $.ajax({
      type: "POST",
      data: { 'branch': branch, 'customertype': customertype },
      url: Server() + 'settings/getbranchexecutive.php',
      success: function(data)
      {
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setState({ data: data })
        } catch (e) {
          context.setState({ data: false })
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    })
  }

  addItem() {
    let context = this;
    context.setState({ load: true, message: 'Get Branch Executive!!!!' })
    $.ajax({
      type: "POST",
      url: Server() + 'executive/get.php',
      success: function(data)
      {
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setState({ executive: data })
        } catch (e) {
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    })
    let items = this.state.items;
    let id = items.length;
    items.push({id: id, branch: this.props.branch });
    this.setState({ items });
  }

  delete(id) {
    let items = this.state.items;
    let item = [];
    items.map((x) => {
      if (x.id != id) {
        item.push(x);
      }
    })
    this.setState({ items: item })
  }

  employee = (id) => event => {
    let value = event.target.value;
    let dropDown = event.target.value;
    value = value.split('->')[0];
    let items = this.state.items;
    items.map((c) => {
      if (c.id == id) {
        c.empid = value;
        c.dropDown = dropDown;
      }
    })
    this.setState({ items: items });
    console.log(items);
  }

  points = (id) => event => {
    let value = event.target.value;
    value = Number(value);
    if (value > 100 || value < 0) {
      alert('Point is more then 100 or Less then 0!!!');
      return;
    }
    let items = this.state.items;
    items.map((c) => {
      if (c.id == id) {
        c.points = event.target.value;
      }
    })
    this.setState({ items: items });
  }

  changePoints = (id) => event => {
    let value = event.target.value;
    value = Number(value);
    if (value > 100 || value < 0) {
      alert('Point is more then 100 or Less then 0!!!');
      return;
    }
    let data = this.state.data;
    data.map((c) => {
      if (id == c.id) {
        c.points = event.target.value;
      }
    })
    this.setState({ data: data })
  }

  deleteData(id) {
    let data = this.state.data;
    let removedData = this.state.removedData;
    let item = [];
    data.map((c) => {
      if (c.id == id) {
        removedData.push(c);
      }
      else {
        item.push(c);
      }
    })
    this.setState({ data: item, removedData: removedData })
  }


  submit() {
    let context = this;
    let array = this.state.items;
    let mainData = this.props.maindata;
    let datas = this.state.data;
    let removedData = this.state.removedData;
    array = array.concat(mainData);
    array = array.concat(datas);
    array.map((c) => {
      c.customer_type = context.props.customertype;
    })
    array = JSON.stringify(array);
    removedData = JSON.stringify(removedData);
    context.setState({ load: true, message: 'Updating Points!!!!' })
    $.ajax({
      type: 'POST',
      data: { 'array': array, 'removedData': removedData },
      url: Server() + 'settings/insert.php',
      success: function(data)
      {
        context.setState({ load: false })
        console.log(data);
        if (data == 1) {
          alert('Points Updated Successfully!!!')
          context.setState({ items: [] })
          context.getExecutive(context.props.branch);
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }


  render() {
    let i = 1;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        { this.state.data ?
          (
            <div>
              <table id='table' width='100%'>
                <tr>
                  <th id='th'><center>Sino</center></th>
                  <th id='th'><center>Executive</center></th>
                  <th id='th' style={{width: '25%'}}><center>Points</center></th>
                  <th id='th' style={{width: '10%'}}><center>Delete</center></th>
                  <th id='th' style={{width: '10%'}}><center>ADD</center></th>
                </tr>
                { this.state.data.map((c) => {
                    return(
                      <tr id='tbody'>
                        <td><center>{i++}</center></td>
                        <td>{c.empid+'->'+c.name}</td>
                        <td><center><Input type='number' fluid placeholder='points' value={c.points} onChange={this.changePoints(c.id)} /></center></td>
                        <td onClick={this.deleteData.bind(this, c.id)}><center>Delete</center></td>
                        <td><center></center></td>
                      </tr>
                    )
                  })
                }
                { this.state.items.map((c) => {
                    return(
                      <tr id='tbody'>
                        <td><center>{i++}</center></td>
                        <td>
                          <center>
                            <datalist id="suggestions1">
                                {this.state.executive.map((x) => {
                                  return (
                                    <option id='box'>{x.id+'->'+x.name}</option>
                                  )
                                })}
                            </datalist>
                            <input style={{height: 35, width: '100%'}} onChange={this.employee(c.id)} autoComplete="on"
                            list="suggestions1" value={c.dropDown} />
                          </center>
                        </td>
                        <td><center><Input type='number' value={c.points} fluid placeholder='points' onChange={this.points(c.id)} /></center></td>
                        <td onClick={this.delete.bind(this, c.id)}><center><u>Delete</u></center></td>
                        <td><center></center></td>
                      </tr>
                    )
                  })
                }
                <tr>
                  <td><center>{i++}</center></td>
                  <td><center></center></td>
                  <td><center></center></td>
                  <td><center></center></td>
                  <td><center><Button onClick={this.addItem.bind(this)} primary>ADD</Button></center></td>
                </tr>
              </table>
            </div>
          ) :
          (<div></div>)
        }
        <br/>
        <center><Button primary onClick={this.submit.bind(this)}>SAVE</Button></center>
      </div>
    );
  }
}

export default Branch;
